/**
 * Shared contact info display for user lists.
 * Shows phone and/or email in a compact inline format.
 */

export function UserContactInfo({ phone, email }: { phone?: string | null; email?: string | null }) {
  if (!phone && !email) return null;
  return (
    <div className="text-xs text-gray-400">
      {phone && <span>{phone}</span>}
      {phone && email && <span className="mx-1">{'\u00B7'}</span>}
      {email && <span>{email}</span>}
    </div>
  );
}
